/**
 * Bug 34319: the Sparta API logs a report open (ReportStatistics) on `/access` only. The first
 * embed uses `/access`; the hourly session-renewal re-embed uses `/refresh` so it is not counted
 * as another open.
 */
export function spartaReportAccessUrl(
  paginatedReportId: string,
  refresh: boolean
): string {
  return `/api/report/${paginatedReportId}/${refresh ? 'refresh' : 'access'}`;
}

/**
 * Bug 37065: the embed URL for a report, with the page's own `rp:` query string and then the
 * server-issued access key as `rp:AccessKey`. Reports that scope rows by the viewer read only that
 * key; every other report ignores it. Without a key the URL is exactly what it was before.
 */
export function paginatedReportEmbedUrl(
  embedUrl: string,
  queryString: string | undefined,
  accessKey: string | null | undefined
): string {
  const url = `${embedUrl}&${queryString || ''}`;
  return accessKey
    ? `${url}&rp:AccessKey=${encodeURIComponent(accessKey)}`
    : url;
}
